import React from "react";
import AlertModal from "components/AlertModal/AlertModal";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import { post, endpoints } from "utils/axios";
import {
  NavbarButton,
} from "./navbarComponents";

const ControllerSettingsNavbar = ({
  snackbarContext,
}) => {
  const handleRestartController = async () => {
    try {
      await post(endpoints.controller.restart);

      snackbarContext.setNotificationTimeOut(
        Color.success,
        "Automação reiniciada."
      );
    } catch (error) {
      snackbarContext.setNotificationTimeOut(
        Color.danger,
        error.detail
      );
    }
  };

  const handleRestartModal = () => {
    AlertModal.fire({
      title: "Reiniciar a automação",
      html: "Deseja reiniciar a automação?",
      type: "error",
      showCancelButton: true,
      confirmButtonColor: "#1D84C6",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Voltar",
      reverseButtons: true,
    }).then(({ value }) => {
      if (value) {
        handleRestartController();
      }
    });
  };

  return (
    <React.Fragment>
      <NavbarButton onClick={() => handleRestartModal()} color="info" breakpoint={444}>
        Reiniciar Automação
      </NavbarButton>
    </React.Fragment>
  );
};

export default withSnackbarConsumer(ControllerSettingsNavbar);
